import React, { useEffect, useState } from 'react';
import { get } from '@/features/shared/lib/api';

const LAUNCH_ICON = '/wp-content/themes/rm-space-v2/extends/html/images/launch-ico-6C7687.png';

export default function ReferencesTable({ resourceId, pageSize = 5 }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [hydrated, setHydrated] = useState(false);
  const [err, setErr] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const fetchRecords = async (perPage, alive = { current: true }) => {
    try {
      const url = `/rm/v1/publication/${encodeURIComponent(resourceId)}/resource_reference?order_by=date&order=desc&record_per_page=${encodeURIComponent(perPage)}&current_page=1`;
      const data = await get(url);
      if (!alive.current) return;
      const result = data?.result || {};
      setRecords(Array.isArray(result.records) ? result.records : []);
      setTotalResults(result.pageInfo?.totalResults || 0);
    } catch (e) {
      if (!alive.current) return;
      setErr(e?.response?.data?.message || e.message);
    }
  };

  useEffect(() => {
    if (!resourceId) return;
    const alive = { current: true };
    (async () => {
      setLoading(true);
      setErr(null);
      await fetchRecords(pageSize, alive);
      if (!alive.current) return;
      setHydrated(true);
      setLoading(false);
    })();
    return () => { alive.current = false; };
  }, [resourceId, pageSize]);

  const handleMore = async () => {
    setFetching(true);
    setErr(null);
    await fetchRecords(totalResults);
    setExpanded(true);
    setFetching(false);
  };

  const hasMore = !expanded && totalResults > records.length;

  const buildMeta = (r) => {
    const t = (v) => (v == null ? '' : String(v));
    if (t(r.title)) return t(r.title);
    if (t(r.meta)) return t(r.meta);
    // const parts = [];
    // const authors = t(r.author);
    // const title = t(r.title);
    // const source = t(r.source_title);
    // const year = t(r.publish_year);
    // const volume = t(r.volume);
    // const issue = t(r.issue);
    // const sp = t(r.start_page);
    // const ep = t(r.end_page);
    // const doi = t(r.doi);
    //
    // if (authors) parts.push(authors);
    // if (title) parts.push(`${title}.`);
    // const pubSeg = [source, year].filter(Boolean).join(' ');
    // const volIss = [volume, issue ? `(${issue})` : ''].filter(Boolean).join('');
    // const pages = sp && ep ? `${sp}-${ep}` : sp || ep || '';
    // const tail = [pubSeg, volIss, pages].filter(Boolean).join(' ');
    // if (tail) parts.push(`${tail}.`);
    // if (doi) parts.push(doi);
    //
    // return parts.join(' ').replace(/\s+/g, ' ').trim();
  };

  if (!resourceId || (hydrated && Array.isArray(records) && records.length === 0)) {
    return null;
  }

  return (
    <div class="mt-[60px] lg:mt-[80px]">
      <h2 class="text-[18px] font-bold mb-5 lg:text-[20px] lg:mb-6">References</h2>

      <div>
        <table class="w-full table-fixed">
          <thead>
            <tr>
              <th class="w-[60px] p-[10px]">No.</th>
              <th class="w-[calc(100%-60px)]">참고문헌 정보</th>
            </tr>
          </thead>
          <tbody>
            {/* Initial loading state only (to avoid flicker on page change) */}
            {loading && !hydrated && (
              <tr>
                <td class="!p-[10px]" colSpan={2}>Loading...</td>
              </tr>
            )}
            {/* Keep showing previous data while fetching new page */}
            {err && hydrated && (
              <tr>
                <td class="!p-[10px] text-red-600" colSpan={2}>{String(err)}</td>
              </tr>
            )}
            {hydrated && !err && Array.isArray(records) && records.length === 0 && (
              <tr>
                <td class="!p-[10px]" colSpan={2}>No references</td>
              </tr>
            )}
            {Array.isArray(records) && records.length > 0 && (
              records.map((r, idx) => (
                <tr key={r.reference_id || idx}>
                  <td class="!p-[10px]">{idx + 1}</td>
                  <td class="!whitespace-normal text-left">
                    {r?.doi ? (
                      <a
                        href={`https://doi.org/${String(r.doi).trim().replace(/^doi:\s*/i, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        class="hover:underline"
                      >
                        {buildMeta(r)}
                      </a>
                    ) : (
                      buildMeta(r)
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {hasMore && (
        <div class="mt-[50px] lg:mt-[40px] flex justify-center">
          <button
            type="button"
            onClick={handleMore}
            disabled={fetching}
            class="inline-flex items-center justify-center gap-1 py-3 px-8 bg-[#F3F5F9] border border-[#E4E8F1] rounded-xl cursor-pointer disabled:opacity-50"
          >
            <span class="text-[14px] text-[#6C7687]">{fetching ? 'Loading...' : 'More'}</span>
            {!fetching && <img class="w-[16px]" alt="link" src={LAUNCH_ICON} />}
          </button>
        </div>
      )}
    </div>
  );
}
